export { default } from './SidebarTypology';
